export const BROCHURE_URL = "/brochure.pdf";
export const CONTACT_EMAIL = "sales@7seasgroupusa.com";
export const CONTACT_PHONE = "1-855-773-2747";

export const buildInquiryMailto = (form) => {
  const subject = `Quote Inquiry — ${form.species || "Lumber Export"}${form.country ? ` to ${form.country}` : ""}`;
  const lines = [
    `Name: ${form.name}`,
    form.company && `Company: ${form.company}`,
    `Email: ${form.email}`,
    form.country && `Destination Country: ${form.country}`,
    form.species && `Species of Interest: ${form.species}`,
    form.volume && `Estimated Volume: ${form.volume}`,
    "",
    form.message,
  ].filter(Boolean);
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join("\n"))}`;
};
